import { createSlice } from "@reduxjs/toolkit";

const loaderSliceNew = createSlice({
    name: 'loader',
    initialState: {
        skeletonLoader: false
    },
    reducers: {
        startLoading: (state, action) => {
            state[action.payload] = true;
        },
        stopLoading: (state, action) => {
            state[action.payload] = false;
        },
        setSkeletonLoader: (state, action) => {
            state.skeletonLoader = action.payload.val;
        }
    }
});

export const { startLoading, stopLoading, setSkeletonLoader } = loaderSliceNew.actions;
export default loaderSliceNew.reducer;